export enum StructuredDataKey {
    BreadCrumb = 'structured-data-breadcrumb',
    Product = 'structured-data-product',
}
